// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_1JHuu","Head":"Hero__Head_3CriL","Title":"Hero__Title_6oeeM","ForGdrHoldersLink":"Hero__ForGdrHoldersLink_2gb9W"};